import { FileReference, FileReferenceId } from '@kaizenplatform/belfast-entity';
import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { createElement } from 'react';

import { DynamicSchemaDefinitionFileIds } from '../../../../../generated/graphql';
import { FileListContainer } from '../../FileList';

interface Props {
  field: Pick<DynamicSchemaDefinitionFileIds, 'key'>;
  value: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  files: ReadonlyArray<FileReference>;
}

const AsFileIds = ({ field, value, files: assetFiles }: Props) => {
  const files = (value.get(field.key) as Array<FileReferenceId>)
    .map((fileId) => assetFiles.find((file) => file.id === fileId))
    .filter((file): file is FileReference => file != null);

  return <FileListContainer files={files} />;
};

export default AsFileIds;
